import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { SessionStorageService } from '../../../shared/services/web-storage/session-storage/session-storage.service';

@Injectable()
export class SessionStorageEntityIdResolver implements Resolve<any> {
  constructor (private sessionStorageService: SessionStorageService) {}

  resolve (route: ActivatedRouteSnapshot): Observable<null> {
    // if route has entity, add it to session storage, otherwise remove it
    const { params: { entity: entityId } } = route;
    entityId
      ? this.sessionStorageService.setItem('entityId', entityId)
      : this.sessionStorageService.removeItem('entityId');
    return of(entityId);
  }
}
